exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".member-avatar[data-v-e2fe60c2]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
